import * as React from 'react'

const ImgSet = ({src, ...props}) => {
  const path = src.slice(0, src.lastIndexOf('/'))
  const file = src.match(/[^\\/]+\.[^\\/]+$/)[0]
  const [name, extension] = file.split('.')

  const generateSrc = (size) => {
    return `${path}/${name}@${size}.${extension} ${size}`
  }

  const srcSet = ['2x', '3x'].map(generateSrc).join(', ')

  return <img src={src} srcSet={srcSet} {...props} />
}

export default ImgSet
